var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5412 27.3337H31.5V26.7087C31.5 25.9037 30.8462 25.25 30.0412 25.25H27.9575C27.1537 25.25 26.5 25.9037 26.5 26.7087V27.3337H25.4587C25.0487 27.3337 24.68 27.505 24.415 27.7775L29 30.17L33.5862 27.7775C33.3212 27.505 32.9512 27.3337 32.5412 27.3337ZM27.75 27.3337V26.7087C27.75 26.5937 27.8437 26.5 27.9587 26.5H30.0425C30.1562 26.5 30.25 26.5937 30.25 26.7087V27.3337H27.75Z",
    fill: "#7EB6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2888 31.4292C29.1075 31.5242 28.8912 31.5242 28.7112 31.4292L24 28.9717V32.5417C24 33.3467 24.6537 34.0004 25.4587 34.0004H32.5425C33.3462 34.0004 34 33.3467 34 32.5417V28.9717L29.2888 31.4292Z",
    fill: "#7EB6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.3337C19.2025 22.3337 17.3337 20.465 17.3337 18.1675C17.3337 15.87 19.2025 14 21.5 14C23.7975 14 25.6662 15.8688 25.6662 18.1663C25.6662 20.4638 23.7975 22.3337 21.5 22.3337Z",
    fill: "#2463AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9587 24.0003C15.775 24.0003 14 25.7753 14 27.959V30.8753C14 31.2165 14.2837 31.5003 14.625 31.5003H22.3337V28.7915C22.3337 27.2253 23.5 25.9328 25.0087 25.7078C25.225 25.074 25.6337 24.5415 26.1587 24.1578C25.325 23.9203 25.28 24.0003 17.9587 24.0003Z",
    fill: "#2463AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/Employee.e97f354f8cf6229d20a55676638cf640.svg";
export { ForwardRef as ReactComponent };